export default {
      id: "Icon--mapIOSMyLocation-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--mapIOSMyLocation",
      toString: function () {
        return this.url;
      }
    }